import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getSquadTvDisplayStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    topBarPressTarget: {
      width: '100%',
      position: 'relative',
    },
    field: {
      flex: 1,
      flexDirection: 'row',
      minHeight: 0,
    },
  });
